import { render, staticRenderFns } from "./EmployeeDetails.vue?vue&type=template&id=3f215ac8"
import script from "./EmployeeDetails.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports